import React, { Component } from "react";
import { Textbox, Textarea } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import $ from "jquery";
import { SHOW_MORE, SHOW_LESS, PRE, POS, CLIENT_CREATE, GET_MASTER_SERVICE, EDIT_CLIENT_CREATED_PLAN, LOGIN_TYPE_ADMIN, CLIENT_EDIT_PLAN, CLIENT_LIST_ROUTE, PREPAID, CHECK_INVOICE_EXIST } from './helper/Constants'
import { DateRangePicker, Alert } from 'rsuite';

import 'rsuite/dist/styles/rsuite-default.css'
import Apihelpers from "./helper/ApiHelper";
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";

class EditCreateClient extends Component {

  constructor(props) {
    super(props);
    this.state = {
      clientPlanList: [],
      serviceList: [],
      clientPlanListJson: "",
      submitDisabled: true,
      StepOneClasses: "blueBtn",
      currentRender: 1,
      SelectedListArray: [],
      isSelectListValidate: null,
      isSelectTwice: false,
      isloaded: false,
      isPrepaid: "active",
      isPostpaid: "",
      paymentAmount: "",
      invoiceNumber: "",
      invoiceImage: "",
      planPeriodstartDate: "",
      planPeriodendDate: "",
      remark: "",
      generatedToken: "",
      haspaymentAmountError: true,
      hasinvoiceImageError: true,
      hasinvoiceNumberError: true,
      hasplanPeriodsError: "null",
      hasInvoiceExistError: false,
      hasRemarkError: true,
      bbUserData: [],
      userData: []
    };
  }

  componentDidMount() {
    // this.getPlanList();
    let bbuserid = this.props.match.params.someid;
    this.loadClientEditDetail(bbuserid);
  }

  checkForEditPlantype() {
    if (this.state.bbActivePlan.plan_type == PREPAID) {
      this.setState({
        isPrepaid: "active",
        isPostpaid: ""
      });
    } else {
      this.setState({
        isPostpaid: "active",
        isPrepaid: ""
      });
    }
  }

  loadClientEditDetail(bbuserid) {
    Apihelpers.getdataresponse(CLIENT_EDIT_PLAN + bbuserid).then(res => {
      if (res.data.status === true) {
        var parserActivePlan = JSON.parse(res.data.data[0].bbuserInfo[0].active_plan);
        this.setState({
          isDetailFound: true,
          userData: res.data.data[0],
          bbUserData: res.data.data[0].bbuserInfo[0],
          bbActivePlan: parserActivePlan,
          bbActiveService: parserActivePlan.service,
          serviceList: res.data.data[1].masterservices,
          clientPlanList: parserActivePlan.service,
          isSelectFieldValidate: 1,
          isloaded: true,
        });
        this.makeListPlan(res.data.data);
        this.checkForEditPlantype();
        this.setState({
          isSelectListValidate: parserActivePlan.service.length
        })
      } else {
        this.setState({
          currentRender: 1,
          isDetailFound: false,
          userData: [],
          bbUserData: [],
          bbActivePlan: {},
          bbActiveService: [],
        });
      }
    });
  }
  //// handle 1st tab 

  makeListPlan() {
    if (this.state.serviceList.length > 0) {
      for (var selectPlan = 1; selectPlan <= this.state.serviceList.length; selectPlan++) {
        this.state.SelectedListArray.push(
          <div className="row avaliableplans" key={selectPlan}>
            <div className="col-8">
              <div className="form-group">
                <label className="control-title">Select plan</label>
                <select className="form-control" id={"planList" + selectPlan} name={"planList" + selectPlan} onChange={this.SelectPlanSubmitValidation}>
                  <option value="">Select Plan</option>
                  {this.state.serviceList.map((singleservice) => {
                    if (this.state.bbActivePlan.service[(selectPlan - 1)] === undefined) {
                      return (<option value={singleservice.serviceName}>{singleservice.serviceName}</option>)
                    } else {
                      if (this.state.bbActivePlan.service[(selectPlan - 1)].plantype === singleservice.serviceName) {
                        return (<option value={singleservice.serviceName} selected>{singleservice.serviceName}</option>)
                      } else {
                        return (<option value={singleservice.serviceName} >{singleservice.serviceName}</option>)
                      }
                    }
                  })}
                </select>
                <div className="" id={"planlistError" + selectPlan}></div>
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label className="control-title">amount <span>(In Rs.)</span></label>
                <div className="inputGroup">
                  <span className="inputIcon">Rs</span>
                  {(this.state.bbActivePlan.service[(selectPlan - 1)] === undefined) ?
                    <input className="form-control" type="number" min="0" autoComplete="off" id={"planAmount" + selectPlan} name={"planAmount" + selectPlan} placeholder="2.00" onBlur={this.SelectPlanSubmitValidation} />
                    : <input className="form-control" type="number" min="0" autoComplete="off" defaultValue={this.state.bbActivePlan.service[(selectPlan - 1)].planamount} id={"planAmount" + selectPlan} name={"planAmount" + selectPlan} placeholder="2.00" onBlur={this.SelectPlanSubmitValidation} />
                  }
                  <div className="" id={"planAmountError" + selectPlan}></div>
                </div>
              </div>
            </div>
          </div>
        );
      }

    }
    this.setState({});
    let self = this;
    $(document).ready(function () {
      $(".avaliableplans:gt(" + (self.state.bbActiveService.length - 1) + ")").hide();
    });

  }

  checkPlanExistEdit(value, existPlanList) {
    for (var row = 0; row < existPlanList.length; row++) {
      if (existPlanList[row]["plantype"] == value) {
        return true
      }
      else {
        return false
      }
    }
  }


  checkPlanExist(value) {
    for (var row = 0; row < this.state.clientPlanList.length; row++) {
      for (var col = 0; col < 2; col++) {
        if (this.state.clientPlanList[row]["plantype"] == value) {
          return true
        }
      }
    }
  }

  checkServiceAmountisValidate() {
    var errorarray = [];
    for (var selectSingleValidate = 1; selectSingleValidate <= this.state.serviceList.length; selectSingleValidate++) {
      if ($("#planList" + selectSingleValidate).val() != "") {
        if ($("#planAmount" + selectSingleValidate).val() == "") {
          errorarray.push("required");
        }
        if ($("#planAmount" + selectSingleValidate).val() < 0) {
          errorarray.push("required");
        }
        if ($("#planAmount" + selectSingleValidate).val().length > 7) {
          errorarray.push("required");
        }
      }
    }
    return errorarray;
  }

  SelectPlanSubmitValidation = () => {
    var self = this;
    var submittedArray = [];
    $(document).ready(function () {
      self.setState({
        clientPlanList: []
      });
      var arr = []
      for (var selectSingleValidate = 1; selectSingleValidate <= self.state.serviceList.length; selectSingleValidate++) {
        if ($("#planList" + selectSingleValidate).val() != "") {
          if ($("#planAmount" + selectSingleValidate).val() == "") {
            $("#planAmountError" + selectSingleValidate).addClass("react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp");
            $("#planAmountError" + selectSingleValidate).text("Required");

          } else {
            if ($("#planAmount" + selectSingleValidate).val() < 0) {
              $("#planAmountError" + selectSingleValidate).addClass("react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp");
              $("#planAmountError" + selectSingleValidate).text("Invalid Amount");
            }
            else if ($("#planAmount" + selectSingleValidate).val().length > 7) {
              $("#planAmountError" + selectSingleValidate).addClass("react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp");
              $("#planAmountError" + selectSingleValidate).text("Invalid Amount");
            }
            else {
              if (self.state.clientPlanList.length == 0) {
                arr["plantype"] = $("#planList" + selectSingleValidate).val();
                arr["planamount"] = $("#planAmount" + selectSingleValidate).val();
                arr["isActive"] = 1;
                submittedArray.push(arr);
                arr = [];
                self.setState({
                  isSelectListValidate: 1,
                  clientPlanList: submittedArray,
                });
              }
              else {
                if (self.checkPlanExist($("#planList" + selectSingleValidate).val()) != true) {
                  arr["plantype"] = $("#planList" + selectSingleValidate).val();
                  arr["planamount"] = $("#planAmount" + selectSingleValidate).val();
                  arr["isActive"] = 1;
                  submittedArray.push(arr);

                  arr = [];
                  self.setState({
                    clientPlanList: submittedArray,
                    isSelectTwice: false
                  });
                }
                else {
                  self.setState({
                    isSelectTwice: true
                  })
                  $("#planList" + selectSingleValidate).val("");
                  $("#planAmount" + selectSingleValidate).val("")
                }
              }
              $("#planAmountError" + selectSingleValidate).removeClass("react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp");
              $("#planAmountError" + selectSingleValidate).text("");
            }
          }
        }
      }
    });
    console.log(this.state.clientPlanList, "jjijiji");
  }

  showHiddenPlans = () => {
    let self = this;
    $(document).ready(function () {
      $(".avaliableplans:gt(" + (self.state.bbActiveService.length - 1) + ")").toggle("fast", function () {
        if ($(this).is(":visible")) {
          var content = '<i class="fa fa-minus"></i>  ' + SHOW_LESS;
          $('.addPlan').html(content);
        }
        else {
          var content = '<i class="fa fa-plus"></i>  ' + SHOW_MORE;
          $('.addPlan').html(content);
        }
      });
    });
  }

  getJsonformattedPlan() {
    var planlistjson = [];
    for (var serList = 0; serList < this.state.clientPlanList.length; serList++) {
      var a = {};
      a['plantype'] = this.state.clientPlanList[serList]['plantype']
      a['planamount'] = this.state.clientPlanList[serList]['planamount']
      a['isActive'] = this.state.clientPlanList[serList]['isActive']
      planlistjson.push(a);
    }
    var planlistjson = JSON.stringify(planlistjson);
    this.setState({
      clientPlanListJson: planlistjson
    });

  }

  toggleValidatingTabone(validateTabOne) {
    this.setState({ validateTabOne });
  }
  toggleValidatingTabTwo(validateTabTwo) {
    this.setState({ validateTabTwo });
  }

  SubmitStepOneForm = () => {
    console.log("111");
    this.toggleValidatingTabone(true);
    this.SelectPlanSubmitValidation();

    if (!this.state.isSelectTwice &&
      this.state.isSelectListValidate &&
      this.state.isSelectFieldValidate &&
      this.checkServiceAmountisValidate().length === 0) {
      console.log("222");

      this.setState({
        currentRender: 2,
      });
      this.getJsonformattedPlan();

    } else {
      console.log("333");

      this.setState({
        currentRender: 1,
      });
    }
  }


  callCreateClientApi(createClientPostData) {
    Apihelpers.postdataresponse(EDIT_CLIENT_CREATED_PLAN, createClientPostData).then(res => {
      if (res.data.status === true) {
        this.setState({
          isSubmitDisabled: false
        })
        // alert("Successfully Updated");
        Alert.success('Successfully Updated')
        var url = window.location.href;
        var arr = url.split("/");
        url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_LIST_ROUTE;

        window.setTimeout(function () {
          window.location.href = url;
        }, 1500);

      } else {
        alert(res.data.message);
        this.setState({
          currentRender: 1
        });
      }
    });
  }

  goBackTab = () => {
    this.setState({
      currentRender: 1
    });
  }

  ////handle 2nd tab 

  SubmitStepTwoForm = (e) => {
    e.preventDefault();
    this.toggleValidatingTabTwo(true);

    if (this.state.isPostpaid == "active") {
      if (this.state.planPeriodstartDate == "" && this.state.planPeriodendDate == "") {
        this.setState({
          hasplanPeriodsError: true
        });
      }
    }

    if (this.state.isPrepaid == "active") {
      if (!this.state.haspaymentAmountError &&
        !this.state.hasinvoiceImageError &&
        !this.state.hasinvoiceNumberError &&
        !this.state.hasRemarkError) {
        if (!this.state.hasInvoiceExistError) {
          const createClientPostData = this.getFormDataPost();
          this.callCreateClientApi(createClientPostData);
        }
      }
    } else if (this.state.isPostpaid == "active") {
      if (
        !this.state.hasplanPeriodsError &&
        !this.state.hasRemarkError) {
        const createClientPostData = this.getFormDataPost();
        this.callCreateClientApi(createClientPostData);
      }
    } else {
      this.setState({
        currentRender: 2
      });
    }
  }

  getFormDataPost() {
    this.setState({
      isSubmitDisabled: true
    })
    var pt = this.state.isPrepaid == "active" ? "Prepaid" : "Postpaid";

    var st_date = this.state.isPostpaid == "active" ? this.state.planPeriodstartDate : null;
    var en_date = this.state.isPostpaid == "active" ? this.state.planPeriodendDate : null;
    const createClientPostData = new FormData();

    createClientPostData.append('start_date', st_date);
    createClientPostData.append('end_date', en_date);
    if (this.state.isPrepaid == "active") {
      let prev_balance = parseFloat(this.state.bbActivePlan.balance)
      let new_balance = parseFloat(this.state.paymentAmount) + prev_balance;
      createClientPostData.append('active_plan', '{ "balance": "' + new_balance + '","plan_type": "' + pt + '","service":' + this.state.clientPlanListJson + "}");
    } else {
      createClientPostData.append('active_plan', '{ "balance": "' + 0 + '","plan_type": "' + pt + '","service":' + this.state.clientPlanListJson + "}");
    }

    createClientPostData.append('address', this.state.clientaddress);
    createClientPostData.append('invoiceNumber', this.state.invoiceNumber);
    createClientPostData.append('invoiceImage', this.state.invoiceImage);
    createClientPostData.append('remark', this.state.remark);
    createClientPostData.append('bbuserid', this.props.match.params.someid);
    createClientPostData.append('userid', this.state.userData._id);
    createClientPostData.append('email', this.state.userData.email);
    createClientPostData.append('amount', this.state.paymentAmount);

    return createClientPostData;
  }

  changeActiveTab = (type) => {
    if (type == PRE) {
      this.setState({
        isPrepaid: "active",
        isPostpaid: ""
      });
    } else {
      this.setState({
        isPrepaid: "",
        isPostpaid: "active"
      });
    }
  }

  // handleDateChange = (dateSelected) => {
  //   if (dateSelected.length !== 0) {
  //     var startDate = new Date(dateSelected[0]);
  //     var month = startDate.getMonth() + 1;
  //     var day = startDate.getDate();
  //     var year = startDate.getFullYear();
  //     startDate = month + "/" + day + "/" + year;
  //     var endDate = new Date(dateSelected[1]);
  //     var month = endDate.getMonth() + 1;
  //     var day = endDate.getDate();
  //     var year = endDate.getFullYear();
  //     endDate = month + "/" + day + "/" + year;
  //     this.setState({
  //       planPeriodstartDate: startDate,
  //       planPeriodendDate: endDate,
  //       hasplanPeriodsError: false
  //     });
  //   } else {
  //     this.setState({
  //       hasplanPeriodsError: true
  //     })
  //   }
  // }


  handleDateChange = (dateSelected) => {
    if (dateSelected.length !== 0) {
      var startDate = new Date(dateSelected[0]);
      var month = startDate.getMonth() + 1;
      var day = startDate.getDate();
      var year = startDate.getFullYear();

      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      startDate = year + "-" + month + "-" + day;
      var endDate = new Date(dateSelected[1]);
      var month = endDate.getMonth() + 1;
      var day = endDate.getDate();
      var year = endDate.getFullYear();

      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }

      endDate = year + "-" + month + "-" + day;
      this.setState({
        planPeriodstartDate: startDate,
        planPeriodendDate: endDate,
        hasplanPeriodsError: false
      });
    } else {
      this.setState({
        hasplanPeriodsError: true
      });
    }
  }



  changeInvoiceNumber(e) {
    if (e.target.value != "") {
      Apihelpers.getdataresponse(CHECK_INVOICE_EXIST + e.target.value).then(res => {
        if (res.data.status === true) {
          this.setState({
            hasInvoiceExistError: false
          });
        }
        else {
          this.setState({
            hasInvoiceExistError: true
          });
        }
      });
    }
  }


  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      const {
        beforeToday,
      } = DateRangePicker;
      return (
        <React.Fragment>
          <div className="wrapper">
            <header className="header">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col text-center">
                    <div className="logo editlogo">
                      <a><img src="/assets/images/logo.png" alt="" /></a>
                    </div>
                  </div>
                  <div style={{ float: "right" }}>
                    <NavLink
                      className="blueBtn btn-sm"
                      to={"/admin/logout"}
                      exact
                      activeClassName="active"
                      style={{ padding: " 5px 10px", fontSize: "12px" }}
                    > LOGOUT
                      </NavLink>
                  </div>
                </div>
              </div>
            </header>
            {this.state.isloaded == true ?
              <div className="container">
                <div className="clientFormSteps">
                  <div className={this.state.currentRender == 1 ? 'step selected active' : this.state.currentRender == 2 || this.state.currentRender == 3 ? 'step selected' : 'step'}>
                    <span className="count">1</span>
                    <span className="text">Edit Client</span>
                  </div>
                  <div className={this.state.currentRender == 2 ? 'step selected active' : this.state.currentRender == 3 ? 'step selected' : 'step'}>
                    <span className="count">2</span>
                    <span className="text">Payment Details</span>
                  </div>
                </div>
                <div className="addClientBox">
                  <div className="clientStepsBlock" style={{ display: `${this.state.currentRender == 1 ? 'block' : 'none'}` }}>
                    <div className="heading"> Create Client </div>
                    <form className="form"
                    //  onSubmit={this.SubmitStepOneForm}
                    >
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group">
                            <label className="control-title">Client name</label>
                            <input className="form-control" type="text" placeholder="Enter Client Name" readOnly value={this.state.bbUserData.business_name} />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label className="control-title">Mobile Number</label>
                            <input className="form-control" type="text" placeholder="Enter Number" readOnly value={this.state.userData.contact_number} />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="control-title">E-mail</label>
                        <input className="form-control" type="text" placeholder="Enter Email ID" readOnly value={this.state.bbUserData.email} />
                      </div>
                      <div className="form-group">
                        <label className="control-title">Address</label>
                        <textarea style={{ height: "61px" }} className="form-control" value={this.state.userData.address} placeholder="Enter Address">{this.state.userData.address}</textarea>
                      </div>
                      {this.state.isSelectListValidate == 0 ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Please Select Any One Plan</div> : <div />}
                      {this.state.isSelectTwice == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">You Select A Plan Twice</div> : <div />}

                      <br />
                      {this.state.SelectedListArray.map(function (selectitem, i) {
                        return selectitem;
                      })
                      }

                      <div className="form-group">
                        <button className="addPlan" onClick={this.showHiddenPlans} type="button"><i className="fa fa-plus"></i>  {SHOW_MORE}</button>
                      </div>
                      <div className="submitRow">
                        {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ?
                          <NavLink
                            to={"/admin/client-list"}
                            className="backBtn"
                            exact
                          >  Back</NavLink>
                          : null}
                        <button className="blueBtn" type="button" onClick={this.SubmitStepOneForm}>Next</button>
                      </div>
                    </form>
                  </div>
                  <div className="clientStepsBlock" style={{ display: `${this.state.currentRender == 2 ? 'block' : 'none'}` }}>
                    <div className="heading">Payment Details</div>
                    <form className="form"
                      method="post"
                      encType="multipart/form-data"
                      onSubmit={this.SubmitStepTwoForm}
                    >
                      <div className="formTab">
                        <span className={this.state.isPrepaid} onClick={() => this.changeActiveTab("pre")}>Prepaid</span>
                        <span className={this.state.isPostpaid} onClick={() => this.changeActiveTab("post")}>Postpaid</span>
                      </div>
                      <div className="formTabContainer">

                        <div className="formTabBlock">
                          {this.state.isPrepaid == "active" ?
                            <div className="row">
                              <div className="col-6">
                                <div className="form-group">
                                  <label className="control-title">amount</label>
                                  <div className="inputGroup">
                                    <span className="inputIcon">Rs</span>
                                    <Textbox
                                      attributesInput={{ // Optional.
                                        id: 'paymentAmount',
                                        name: 'paymentAmount',
                                        type: 'number',
                                        placeholder: "Enter Amount",
                                        className: "form-control",
                                        autoComplete: "off",
                                        min: 1
                                      }}
                                      value={this.state.paymentAmount}
                                      disabled={false} // Optional.[Bool].Default: false.
                                      validate={this.state.validateTabTwo} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                                      validationCallback={res => {
                                        this.setState({ haspaymentAmountError: res, validateTabTwo: false });
                                      }
                                      }
                                      onChange={(paymentAmount, e) => {
                                        this.setState({ paymentAmount });
                                      }}
                                      onBlur={(e) => { console.log() }}

                                      validationOption={{
                                        name: 'Amount',
                                        check: true,
                                        required: true,
                                        customFunc: amt => {
                                          const reg = /^\d*$/;
                                          if (reg.test(String(amt))) {
                                            if (amt.length > 7) {
                                              return "Amount Should Max 7 Digit";
                                            } else {
                                              return true;
                                            }
                                          } else {
                                            return "Enter Valid Amount";
                                          }
                                        }
                                      }}
                                    />
                                    {/* <input className="form-control" type="text" value="10,000" name="" /> */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-group">
                                  <label className="control-title">Invoice Number</label>
                                  <Textbox
                                    attributesInput={{ // Optional.
                                      id: 'invoiceNumber',
                                      name: 'invoiceNumber',
                                      type: 'text',
                                      placeholder: "Enter Number",
                                      className: "form-control",
                                      autoComplete: "off"
                                    }}
                                    value={this.state.invoiceNumber}
                                    disabled={false} // Optional.[Bool].Default: false.
                                    validate={this.state.validateTabTwo} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                                    validationCallback={res => {
                                      this.setState({ hasinvoiceNumberError: res, validateTabTwo: false })
                                    }
                                    }
                                    onChange={(invoiceNumber, e) => {
                                      this.setState({ invoiceNumber });
                                    }}
                                    onBlur={(e) => {
                                      this.changeInvoiceNumber(e)
                                    }}
                                    validationOption={{
                                      name: 'Invoice Number',
                                      check: true,
                                      required: true,
                                      customFunc: invoice => {
                                        if (invoice.length > 30) {
                                          return "Invoice Number Max 30 Char";
                                        } else {
                                          return true;
                                        }
                                      }
                                    }}
                                  />
                                  {this.state.hasInvoiceExistError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Invoice Number Already Exist </div> : <div />}

                                </div>
                              </div>
                            </div>
                            : <div />}

                          {this.state.isPrepaid == "active" ?
                            <div className="form-group">
                              <label className="control-title">Upload Invoice</label>
                              <div className="uploadFile">
                                <Textbox
                                  attributesInput={{ // Optional.
                                    id: 'invoiceImage',
                                    name: 'invoiceImage',
                                    type: 'file',
                                    placeholder: "Enter Number",
                                    className: "form-control",
                                    autoComplete: "off",
                                    accept: "image/*,.doc, .docx,.pdf"
                                  }}

                                  disabled={false} // Optional.[Bool].Default: false.
                                  validate={this.state.validateTabTwo} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                                  validationCallback={res => {
                                    this.setState({ hasinvoiceImageError: res, validateTabTwo: false })
                                  }
                                  }
                                  onChange={(invoiceImage, e) => {
                                    this.setState({ invoiceImage: e.target.files[0] });
                                  }}
                                  onBlur={(e) => { console.log() }}
                                  validationOption={{
                                    name: 'Invoice Image',
                                    check: true,
                                    required: true,
                                    customFunc: imagefile => {
                                      console.log(imagefile);
                                      var val = imagefile.toLowerCase(),
                                        regex = new RegExp("(.*?)\.(jpg|jpeg|pdf|png|doc|docx)$");
                                      var sizeInKB = this.state.invoiceImage.size;

                                      if (!(regex.test(val))) {
                                        $(this).val('');
                                        return "Enter Valid Image(jpg,jpeg,pdf,png,doc,docx)";
                                      } else {
                                        $(this).val('');
                                        if (sizeInKB < 2000 || sizeInKB > 5000000) {
                                          return "Invalid Size(Size Should be 2KB to 5MB)";
                                        } else {
                                          return true;
                                        }
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            : <div />}

                          {this.state.isPostpaid == "active" ?
                            <div className="form-group">
                              <label className="control-title">Plan Period</label>
                              <div className="dateInput">

                                <DateRangePicker
                                  format="MMM DD, YYYY"
                                  disabledDate={beforeToday()}
                                  onChange={this.handleDateChange}
                                  placeholder="Eg. Apr 01, 2020"
                                  autoComplete="off"
                                />
                                {this.state.hasplanPeriodsError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Please select Period </div> : <div />}
                                {/* <input className="form-control" placeholder="Apr 01, 2020   -   Jun 30, 2020" type="text" /> */}
                              </div>
                            </div>
                            :
                            <div />
                          }

                          <div className="form-group">
                            <label className="control-title">Remarks</label>
                            <Textarea
                              attributesInput={{ // Optional.
                                id: 'remark',
                                name: 'remark',
                                type: 'text',
                                placeholder: "Enter Remark",
                                className: "form-control",
                                autoComplete: "off"
                              }}
                              value={this.state.remark}
                              disabled={false} // Optional.[Bool].Default: false.
                              validate={this.state.validateTabTwo} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                              validationCallback={res => {
                                this.setState({ hasRemarkError: res, validateTabTwo: false })
                              }
                              }
                              onChange={(remark, e) => {
                                this.setState({ remark });
                              }}
                              onBlur={(e) => { console.log() }}

                              validationOption={{
                                name: 'Remark',
                                check: true,
                                required: true,
                                customFunc: remark => {
                                  if (remark.length > 200) {
                                    return "Remark Should Max 200 Char.";
                                  } else {
                                    return true;
                                  }
                                }
                              }}
                            />
                            {/* <textarea style={{ height: "61px" }} className="form-control" placeholder="Enter Remarks"></textarea> */}
                          </div>
                        </div>
                      </div>
                      <div className="submitRow">
                        <button className="backBtn" onClick={this.goBackTab} type="button">Back</button>
                        <button className="blueBtn next"
                          //  onClick={this.SubmitStepTwoForm}
                          type="submit" disabled={this.state.isSubmitDisabled}>Submit</button>
                      </div>
                    </form>
                  </div>

                  {/* <div className="clientStepsBlock" style={{ display: `${this.state.currentRender == 3 ? 'block' : 'none'}` }}>
              <div className="heading"> Authentication Token </div>
              <form className="form">
                <div className="form-group">
                  <label className="control-title">Token</label>
                  <textarea className="form-control tokenBox" id="GeneratedtokenBox" readonly="readonly">{this.state.generatedToken}</textarea>
                </div>
                <div className="submitRow">
                  {/* <!-- <button className="blueBtn">Submit</button> --> */}
                  {/* <NavLink
                    className="blueBtn"
                    to={"/admin/client-list"}
                    exact
                    activeClassName="active"
                  > Go To List
                  </NavLink> */}

                  {/* </div>
              </form>
            </div> */}

                </div>

              </div>
              :
              <div className="loader" style={{ display: "block" }}>
                <div className="bg"></div>
                <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
              </div>
            }

          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }

  }
}

export default EditCreateClient;
